<template>
  <el-dialog
    title="学生评教"
    class="comment"
    :close-on-click-modal="false"
    :visible="mentData.state"
    width="600px"
    append-to-body
    @close="closeModal()"
  >
    <div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="ruleValidate"
        label-width="70px"
        class="demo-ruleForm"
      >
        <div class="topc">
          <p>
            1.本次课老师有无不良现象，如吸烟、接打手机、迟到、早退、无故不上课？
          </p>
          <el-radio-group
            v-model="ruleForm.value1"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>2.本次课老师上课是否使用PPT等信息化手段？</p>
          <el-radio-group
            v-model="ruleForm.value2"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>
            3.本次课老师是否有语言不当情况，如侮辱学生、教学案例举例不当、反国家反党语言、宣传宗教、售卖物品、说违背道德的话等？
          </p>
          <el-radio-group
            v-model="ruleForm.value3"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>4.本次课老师是否按照课本知识进行讲授，并适当拓展丰富内容？</p>
          <el-radio-group
            v-model="ruleForm.value4"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>5.本次老师上课是否有吸引力，教学方式是否丰富多样？</p>
          <el-radio-group
            v-model="ruleForm.value5"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">多样</el-radio>
            <el-radio label="B">单一</el-radio>
            <el-radio label="C">乏味</el-radio>
          </el-radio-group>
          <p>6.本次课老师是否为学生提供讨论、质疑、探究、合作、交流的机会？</p>
          <el-radio-group
            v-model="ruleForm.value6"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>7.本次课老师是否布置作业？</p>
          <el-radio-group
            v-model="ruleForm.value7"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A有</el-radio>
            <el-radio label="B">B没有</el-radio>
          </el-radio-group>
          <p>8.你对本次课的学习接受度如何？</p>
          <el-radio-group
            v-model="ruleForm.value8"
            :disabled="disabled"
            direction="horizontal"
          >
            <el-radio label="A">A能够全部听懂</el-radio>
            <el-radio label="B">B大多数能够听懂</el-radio>
            <el-radio label="C">C基本可以听懂 </el-radio>
            <el-radio label="D">D听不懂</el-radio>
          </el-radio-group>
          <el-input
            v-model="ruleForm.reason"
            :rows="3"
            autosize
            type="textarea"
            placeholder="原因"
            v-show="ruleForm.value8 == 'D'"
          />
        </div>
        <el-form-item label="意见反馈">
          <el-input v-model="ruleForm.remark" 
            :rows="3"
            autosize
            type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import * as api from '@/api/overseasChinese/overseasChinese'
export default {
  name: "editComment",
  props: {
    mentData: {
      type: Object,
      required: true,
    },
    info: {
      type: Object,
    default () {
        return {};
    }},
    id: {
      type: String,
    },
  },
  data() {
    return {
      ruleForm: {
        radio: "",
        radio1: "",
        checkList: [],
        radio3: 1,
        value1: "B",
        value2: "B",
        value3: "B",
        value4: "A",
        value5: "A",
        value6: "A",
        value7: "A",
        value8: "A",
        reason: "",
        remark:"",
      },
      ruleValidate: {
        type: [
          { required: true, message: "该项必须填写", trigger: "blur" },
          {
            min: 1,
            max: 80,
            message: "长度在 1 到 80 个字符",
            trigger: "blur",
          },
        ],
        description: [
          { required: true, message: "该项必须填写", trigger: "blur" },
          {
            min: 1,
            max: 80,
            message: "长度在 1 到 80 个字符",
            trigger: "blur",
          },
        ],
      }, // 表单验证
      disabled: false,
    };
  },
  mounted() {
    this.getEvaluaInfo()
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // addObj(this.formValidate).then(res => {
          //     if (res.data.code == 0) {
          //         this.subDisabled = false;
          //         this.$refs[formName].resetFields();
          //         this.closeModal()
          //     } else {
          //         this.subDisabled = false;
          //         this.$alert(res.data.msg, '提示', {
          //             confirmButtonText: '确定',
          //             type: 'warning'
          //         });
          //     }
          // })
        }
      });
    },
    closeModal() {
      this.mentData.state = false;
    },
    getEvaluaInfo() {
      api.selectEvaluaInfo({id:this.id}).then(({data}) => {
        if(data.code == 0 && data.data) {
          this.disabled=true;
          let arr = data.data.learnEffectItem.split(',')
          this.ruleForm.value1 = arr[0]
          this.ruleForm.value2 = arr[1]
          this.ruleForm.value3 = arr[2]
          this.ruleForm.value4 = arr[3]
          this.ruleForm.value5 = arr[4]
          this.ruleForm.value6 = arr[5]
          this.ruleForm.value7 = arr[6]
          this.ruleForm.value8 = arr[7]
          this.ruleForm.reason = data.data.reason
          this.ruleForm.remark = data.data.remark
        }else{
          this.disabled=false;
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
.comment .topc .el-radio {
  width: 100%;
  padding: 5px 0;
}
.comment .el-checkbox {
  width: 100%;
}
.el-radio-group{
    display: flex;
}
p{
    margin-top: 5px;
    margin-bottom: 5px;
}
</style>